import createReactComponent from '../createReactComponent';
export default createReactComponent('servicemark', 'IconServicemark', [
  [
    'path',
    { d: 'M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5', key: 'svg-0' },
  ],
  ['path', { d: 'M13 15v-6l3 4l3 -4v6', key: 'svg-1' }],
]);
